import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from './Constants';

const AdminLanguagePage = ({ clickChangeMenu }) => {
    const [languages, setLanguages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchLanguages = async () => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get(`${API_URL}/languages`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setLanguages(res.data);
        } catch (err) {
            console.error("Error fetching languages:", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchLanguages();
    }, []);

    return (
        <div className="social-box" style={{ padding: '20px', backgroundColor: 'white', borderRadius: '4px', margin: '15px' }}>
            <h3 className="page-title" style={{ marginBottom: '20px' }}>Ngôn ngữ</h3>
            <div className="header" style={{ marginBottom: '15px' }}>
                <a className="btn btn-primary" href="#" style={{ borderRadius: '2px', backgroundColor: '#336699' }} onClick={e => e.preventDefault()}>
                    <i className="icon-pencil" /> Tạo Ngôn ngữ
                </a>
            </div>
            <div className="body">
                <table className="table table-striped table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>Tên</th>
                            <th>Ký hiệu</th>
                            <th>Code</th>
                            <th>Ảnh</th>
                            <th>Thứ tự</th>
                            <th>Kích hoạt</th>
                            <th width="150px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr><td colSpan="7" className="text-center">Đang tải...</td></tr>
                        ) : (
                            languages.map((item) => (
                                <tr key={item.id}>
                                    <td style={{ color: '#2891cf', fontWeight: 'bold' }}>{item.name}</td>
                                    <td>{item.fullcode}</td>
                                    <td><code>{item.code}</code></td>
                                    <td>
                                        {item.flag && <img src={item.flag} alt={item.name} style={{ height: '20px' }} />}
                                    </td>
                                    <td>{item.order}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        <input type="checkbox" checked={item.active || false} readOnly />
                                    </td>
                                    <td style={{ textAlign: 'right' }}>
                                        <a className="btn btn-primary btn-small" href="#" style={{ backgroundColor: '#5bb75b', border: 'none', marginRight: '5px' }} onClick={e => e.preventDefault()}>
                                            Sửa
                                        </a>
                                        <a className="btn btn-danger btn-small" href="#" style={{ backgroundColor: '#cc0000', border: 'none' }} onClick={e => e.preventDefault()}>
                                            Xóa
                                        </a>
                                    </td>
                                </tr>
                            ))
                        )}
                        {languages.length === 0 && !isLoading && (
                            <tr><td colSpan="7" className="text-center">Không có dữ liệu</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminLanguagePage;
